export const genericShareDescription = "Come to VisitSanctuaryCity.com for more!";
